import useReveal from "@/hooks/useReveal";

const defaultTestimonials = [
  {
    initials: "MV",
    name: "Ms. Valdez",
    photo: "/portraits/valdez.png",
    quote:
      "This firm is not in the business of telling you what you want to hear. It is focused on what is best for your family and winning your case. Founded by someone who went through this himself, the level of empathy and legal experience is the kind most attorneys cannot match.",
  },
  {
    initials: "ML",
    name: "Ms. Lee",
    photo: "/portraits/lee.png",
    quote:
      "I went from not having any custody and not being able to see my child for several months, to now gaining joint physical and legal custody. Jos Family Law will fight for your case and what is fair.",
  },
  {
    initials: "MK",
    name: "Mr. Kogami",
    photo: "/portraits/kogami.png",
    quote:
      "If it wasn't for Jos Family Law, I would not have been able to come to a settlement that I felt was fair for both parties.",
  },
];

function Star() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" className="fill-teal">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  );
}

export default function Testimonials({
  items = defaultTestimonials,
  heading,
  clientLabel = "Child Custody Client",
} = {}) {
  useReveal();

  const defaultHeading = (
    <>
      Satisfied <span className="italic">child custody</span> clients.
    </>
  );

  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-teal-light/40 py-24 md:py-36"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 reveal">
          <div>
            <div className="flex items-center gap-4 mb-6">
              <span className="w-10 h-px bg-teal" />
              <p className="font-mono text-[11px] tracking-[0.28em] uppercase text-gray-600">
                In Their Words
              </p>
            </div>
            <h2 className="font-display text-[40px] md:text-[52px] lg:text-[60px] leading-[1.04] tracking-tight text-ink max-w-[20ch]">
              {heading || defaultHeading}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 items-stretch">
          {items.map((t, i) => (
            <article
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="relative bg-paper border border-gray-200/70 p-8 md:p-10 reveal flex flex-col h-full"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="flex items-center gap-1 mb-6">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} />
                ))}
              </div>
              <p className="font-display italic text-[22px] md:text-[24px] leading-[1.4] text-ink flex-grow">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-8 pt-6 border-t border-gray-200/70 flex items-center gap-4">
                {t.photo ? (
                  <img
                    src={t.photo}
                    alt={`Portrait of ${t.name}`}
                    className="w-12 h-12 object-cover bg-ink/10 select-none shrink-0"
                    draggable={false}
                    loading="lazy"
                  />
                ) : (
                  <div className="w-12 h-12 bg-ink text-paper flex items-center justify-center font-mono text-xs tracking-widest shrink-0">
                    {t.initials || t.name.split(" ").map((s) => s[0]).join("")}
                  </div>
                )}
                <div>
                  <p className="font-medium text-ink text-sm">{t.name}</p>
                  <p className="font-mono text-[10px] tracking-[0.24em] uppercase text-gray-600">
                    {clientLabel}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
